
export class ClientItem {
    constructor(
        public SRNumber: string,
        public Area: string,
        public SubArea: string,
        public R3Fechaservicio: string,
        public INSProduct: string,
        public TipoAclaracion: string,
        public ContactEmail: number,
        public Abstract: string,
        public Created: string,
        public R3Idproveedor: string,
        public RequestNotes: [],
        public ShowButton:boolean,
        public DisableButton:boolean = false
    ){}

    
}
